import { Grid, Box } from "@mui/system";
import { LiveCodeBlock } from "../../LiveCodeBlock";
import VerticalLinearStepper from "../VerticalLinearStepper";
import { Alert, Typography } from "@mui/material";

import { FuturisticHeader } from "../../FuturisticHeader";
import { RecapCard } from "../../RecapCard";
import { QuizToggle } from "../../QuizToggle";

export const KdappontCssLesson5 = () => {
  const combinatorSubjects = [
    {
      label: "Descendant Selector | Spatie",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                Selecteert <b>alles</b> wat in de ouder zit. Children,
                Grandchildren, Great grandchildren...
              </Typography>
            </Alert>
            <LiveCodeBlock
              live={false}
              code={`div p {
  background-color: hotpink;
}
section {
  border: 1px solid grey;
  padding: 10px;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<div>
  <p>Child 1</p>
  <section>
    <p>Grandchild</p>
  </section>
</div>`}
            />
          </Grid>
          <Grid size={2}>
            <QuizToggle
              question='Wat als ik de selector verander naar "div section p"?'
              defaultView={
                // De situatie zoals in de code links (Alles roze)
                <div style={{ border: "1px solid grey", padding: "10px" }}>
                  <p style={{ backgroundColor: "hotpink", padding: "5px" }}>
                    Child 1
                  </p>
                  <section
                    style={{
                      border: "1px dashed grey",
                      padding: "5px",
                      marginLeft: "10px",
                    }}
                  >
                    <p style={{ backgroundColor: "hotpink", padding: "5px" }}>
                      Grandchild
                    </p>
                  </section>
                </div>
              }
              answerView={
                <div style={{ border: "1px solid grey", padding: "10px" }}>
                  <p style={{ padding: "5px" }}>Child 1</p>
                  <section
                    style={{
                      border: "1px dashed grey",
                      padding: "5px",
                      marginLeft: "10px",
                    }}
                  >
                    <p style={{ backgroundColor: "hotpink", padding: "5px" }}>
                      Grandchild
                    </p>
                  </section>
                </div>
              }
            />
          </Grid>
        </Grid>
      ),
    },
    {
      label: "Child Selector | >",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                Selecteert alleen <b>directe</b> children. Grandchildren worden
                genegeerd.
              </Typography>
            </Alert>
            <LiveCodeBlock
              live={false}
              code={`div > p {
  background-color: yellow;
}
section {
  border: 1px solid grey;
  padding: 10px;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<div>
  <p>Child 1</p>
  <section>
    <p>Grandchild</p>
  </section>
  <p>Child 2</p>
</div>`}
            />
          </Grid>
          <Grid size={2}>
            <QuizToggle
              question="Wat als ik de selector wijzig naar 'div > section > p'?"
              defaultView={
                // Situatie > (Alleen direct kind)
                <div style={{ border: "1px solid grey", padding: "10px" }}>
                  <p style={{ backgroundColor: "yellow", padding: "5px" }}>
                    Child 1
                  </p>
                  <section
                    style={{
                      border: "1px dashed grey",
                      padding: "5px",
                      marginLeft: "10px",
                    }}
                  >
                    <p style={{ padding: "5px" }}>Grandchild</p>
                  </section>
                  <p style={{ backgroundColor: "yellow", padding: "5px" }}>
                    Child 2
                  </p>
                </div>
              }
              answerView={
                // Situatie Spatie (Allebei geel)
                <div style={{ border: "1px solid grey", padding: "10px" }}>
                  <p style={{ padding: "5px" }}>Child 1</p>
                  <section
                    style={{
                      border: "1px dashed grey",
                      padding: "5px",
                      marginLeft: "10px",
                      backgroundColor: "yellow",
                    }}
                  >
                    <p style={{ padding: "5px" }}>Grandchild</p>
                  </section>
                  <p style={{ padding: "5px" }}>Child 2</p>
                </div>
              }
            />
          </Grid>
        </Grid>
      ),
    },
    {
      label: "Next Sibling Selector | +",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                Selecteert het element dat <b>direct</b> na de 'sibling' komt.
              </Typography>
            </Alert>
            <LiveCodeBlock
              live={false}
              code={`div + p {
  background-color: lightblue;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<div>CSS is awesome</div>
<p>Sibling 1</p>
<p>Sibling 2</p>`}
            />
          </Grid>
          <Grid size={2}>
            <QuizToggle
              question="Wat als ik een <span> tussen de div en de <p> zet?"
              defaultView={
                <>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    CSS is awesome
                  </div>
                  <p style={{ backgroundColor: "lightblue", padding: "5px" }}>
                    Sibling 1
                  </p>
                  <p style={{ padding: "5px" }}>Sibling 2</p>
                </>
              }
              answerView={
                <>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    CSS is awesome
                  </div>
                  <span>Ik zit in de weg 🚧</span>
                  <p style={{ padding: "5px" }}>Sibling 1</p>
                  <p style={{ padding: "5px" }}>Sibling 2</p>
                </>
              }
            />
          </Grid>
        </Grid>
      ),
    },
    {
      label: "Subsequent Sibling Selector | ~",
      main: (
        <Grid container columns={6} spacing={2}>
          <Grid size={4}>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body2">
                Selecteert <b>alle</b> siblings die erna komen
              </Typography>
            </Alert>
            <LiveCodeBlock
              live={false}
              code={`div ~ p.banaan {
  background-color: lightblue;
}`}
              language="css"
            />
            <br />
            <LiveCodeBlock
              live={false}
              code={`<div>CSS is awesome</div>
<p class="banaan">Sibling 1</p>
<span>Sibling 2</span>
<p class="banaan">Sibling 3</p>
<p>Sibling 4</p>`}
            />
          </Grid>
          <Grid size={2}>
            <QuizToggle
              question="Wat als ik de selector aanpas naar 'div ~ span + p.banaan'?"
              defaultView={
                // Situatie ~ (Alles groen)
                <>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    CSS is awesome
                  </div>
                  <p style={{ backgroundColor: "lightblue", padding: "5px" }}>
                    Sibling 1
                  </p>
                  <span
                    style={{
                      padding: "5px",
                    }}
                  >
                    Sibling 2
                  </span>
                  <p style={{ backgroundColor: "lightblue", padding: "5px" }}>
                    Sibling 3
                  </p>
                  <p style={{ padding: "5px" }}>Sibling 4</p>
                </>
              }
              answerView={
                // Situatie + (Alleen de eerste)
                <>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: "5px",
                      marginBottom: "10px",
                    }}
                  >
                    CSS is awesome
                  </div>
                  <p style={{ padding: "5px" }}>Sibling 1</p>
                  <span
                    style={{
                      padding: "5px",
                    }}
                  >
                    Sibling 2
                  </span>
                  <p style={{ padding: "5px", backgroundColor: "lightblue" }}>
                    Sibling 3
                  </p>
                  <p style={{ padding: "5px" }}>Sibling 4</p>
                </>
              }
            />
          </Grid>
        </Grid>
      ),
    },
    {
      label: "⛓️ Chaining",
      main: (
        <Box>
          <Grid container columns={6} spacing={2}>
            <Grid size={4}>
              <LiveCodeBlock
                live={false}
                code={`<div class="zolder">
  <div class="oude-doos">📦 Oude Doos</div>
  <div class="verhuis-doos">📦 Verhuisdoos</div>
  
  <span>(Rommel...)</span>
  
  <div class="koffer">
    <div class="winterjas">🧥 Winterjas</div>
    <div class="sjaal">🧣 Sjaal</div>
    
    <span>(Oude bonnetjes...)</span>
    
    <div class="remote">🎮 Gevonden!</div>
  </div>
</div>`}
              />
              <br />
              <LiveCodeBlock
                live={false}
                language="css"
                code={`div.zolder > .oude-doos + .verhuis-doos ~ .koffer > .winterjas + .sjaal ~ .remote {
    background: red;
}`}
              />
            </Grid>
            <Grid size={2}>
              <div className="zolder">
                <div className="oude-doos">📦 Oude Doos</div>
                <div className="verhuis-doos">📦 Verhuisdoos</div>

                <span>(Rommel...)</span>

                <div className="koffer">
                  <div className="winterjas">🧥 Winterjas</div>
                  <div className="sjaal">🧣 Sjaal</div>

                  <span>(Oude bonnetjes...)</span>

                  <div className="remote" style={{ background: "red" }}>
                    🎮 Gevonden!
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "👨🏼‍🏫 Voor vandaag",
          description: `Centering | Combinators | Pseudo elements`,
          content: (
            <FuturisticHeader
              items={[
                "Centering",
                "COMBINATORS",
                "PSEUDO-CLASSES",
                "PSEUDO-ELEMENTS",
              ]}
            />
          ),
        },
        {
          label: "↔️ CSS Align",
          description: "Centreren: The Classic Way",
          content: (
            <Grid container columns={6} spacing={2}>
              <Grid size={4}>
                <Alert severity="info" sx={{ mb: 2 }}>
                  <Typography variant="body2">
                    Geef het een <code>width</code> en gebruik{" "}
                    <code>margin:auto</code>.
                  </Typography>
                </Alert>
                <LiveCodeBlock
                  live={false}
                  code={`.container {
  border: 2px dashed grey;
}

.center-me {
  width: 50%;      /* 1. Ik moet kleiner zijn dan mijn parent */
  margin: auto;    /* 2. Verdeel de ruimte links en rechts gelijk */
  background: hotpink;
  text-align: center; 
  padding: 10px;
}`}
                  language="css"
                />
                <br />
                <LiveCodeBlock
                  live={false}
                  code={`<div class="container">
  <div class="center-me">
    Ik sta in het midden!
  </div>
</div>`}
                />
              </Grid>
              <Grid size={2}>
                <Typography variant="h6">Resultaat:</Typography>
                <div
                  style={{
                    border: "2px dashed grey",
                    padding: "10px",
                    background: "#f9f9f9",
                  }}
                >
                  <div
                    style={{
                      width: "50%",
                      margin: "auto",
                      background: "hotpink",
                      color: "white",
                      padding: "10px",
                      textAlign: "center",
                      boxShadow: "3px 3px 0px rgba(0,0,0,0.2)",
                    }}
                  >
                    Ik sta in het midden!
                  </div>
                </div>
                <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
                  (Werkt alleen horizontaal!)
                </Typography>
              </Grid>
            </Grid>
          ),
        },
        {
          label: "👨‍👩‍👧‍👦 CSS Combinators",
          description:
            "Relaties tussen elementen <br/>De HTML volgorde / boomstructuur is hier allesbepalend",
          content: (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {combinatorSubjects.map((subject, index) => (
                <RecapCard key={index} subject={subject} />
              ))}
            </Box>
          ),
        },
        {
          label: "🎭 CSS Pseudo-class",
          description: "",
          content: (
            <Grid container columns={6} spacing={2}>
              <Grid size={4}>
                <Alert severity="info" sx={{ mb: 2 }}>
                  <Typography variant="body2">
                    Een pseudo-class begint met een enkele dubbele punt. Het
                    geeft controle over de status van een element.
                  </Typography>
                </Alert>
                <LiveCodeBlock
                  live={false}
                  code={`button:hover {
  background-color: green;
  cursor: pointer;
}
input:focus {
  background-color: yellow;
}`}
                  language="css"
                />{" "}
                <LiveCodeBlock
                  live={false}
                  code={`<button>Hover me!</button>
<input placeholder="Klik in mij..." />`}
                />
              </Grid>
              <Grid size={2}>
                <style>
                  {`
                    .demo-btn:hover { background-color: green !important; cursor: pointer; }
                    .demo-input:focus { background-color: yellow !important;  }
                    .demo-zebra li:nth-child(even) { background-color: #e0e0e0; }
                    .demo-zebra li { padding: 5px; border-bottom: 1px solid #eee; }
                  `}
                </style>

                <Typography variant="h6">1. Interactie</Typography>
                <button
                  className="demo-btn"
                  style={{
                    padding: "10px 20px",
                    border: "1px solid grey",
                    borderRadius: "4px",
                    background: "white",
                    transition: "0.2s",
                  }}
                >
                  Hover me!
                </button>
                <br />
                <br />
                <input
                  className="demo-input"
                  placeholder="Klik in mij..."
                  style={{
                    padding: "8px",
                    border: "1px solid grey",
                    width: "100%",
                  }}
                />
              </Grid>
              <Grid size={4}>
                <LiveCodeBlock
                  live={false}
                  code={`li:nth-child(odd) {
  background-color: #fff;
}
li:nth-child(even) {
  background-color: #f2f2f2;
}`}
                  language="css"
                />{" "}
                <LiveCodeBlock
                  live={false}
                  code={`<ul>
  <li>Item 1</li>
  <li>Item 2</li>
  <li>Item 3</li>
  <li>Item 4</li>
</ul>`}
                />
              </Grid>
              <Grid size={2}>
                <style>
                  {`
                    .demo-btn:hover { background-color: green !important; cursor: pointer; }
                    .demo-input:focus { background-color: yellow !important;  }
                    .demo-zebra li:nth-child(even) { background-color: #e0e0e0; }
                    .demo-zebra li { padding: 5px; border-bottom: 1px solid #eee; }
                  `}
                </style>

                <Typography variant="h6">2. Zebra list (:nth-child)</Typography>
                <ul
                  className="demo-zebra"
                  style={{
                    listStyle: "none",
                    padding: 0,
                    border: "1px solid #ccc",
                  }}
                >
                  <li>Item 1</li>
                  <li>Item 2</li>
                  <li>Item 3</li>
                  <li>Item 4</li>
                  <li>Item 5</li>
                </ul>
              </Grid>
              <Grid size={4}>
                <LiveCodeBlock
                  live={false}
                  code={`div > span {
  display: none;
}
div:hover > span {
  display: block;
}`}
                  language="css"
                />{" "}
                <LiveCodeBlock
                  live={false}
                  code={`<div>
  Hover me!
  <span>Hello world!</span>
</div>`}
                />
              </Grid>
              <Grid size={2}>
                <style>
                  {`
                    .demo-btn:hover { background-color: green !important; cursor: pointer; }
                    .demo-input:focus { background-color: yellow !important;  }
                    .demo-zebra li:nth-child(even) { background-color: #e0e0e0; }
                    .demo-zebra li { padding: 5px; border-bottom: 1px solid #eee; }
                  `}
                </style>

                <Typography variant="h6">3. Pseudo show/hide</Typography>

                <Box
                  sx={{
                    "&:hover > span": {
                      display: "block",
                    },

                    span: {
                      "&:hover": {
                        display: "block",
                      },
                      display: "none",
                    },
                  }}
                >
                  Hover me!
                  <span>Hello world!</span>
                </Box>
              </Grid>
            </Grid>
          ),
        },
        {
          label: "🚀 Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 2 :: CSS ➡️ LES 5`,
          content: (
            <Alert severity="error" sx={{ alignItems: "center" }}>
              <Typography variant="h5">
                Maak uiteraard eerst je oefeningen van Les 4 af - of herhaal ze.
                Vergeet ook niet de W3School quizes.
              </Typography>
            </Alert>
          ),
        },
      ]}
    />
  );
};
